import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import NewsletterFooter from '../forms/NewsletterForm';

import styles from '../../../styles/modals/media-kit-modal.module.scss';

const propTypes = {
    onClose: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const MediaKitModal = ({ className, onClose, visible }) => {
    const onComplete = useCallback(() => {
        setTimeout(onClose, 1800);
    }, [onClose]);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.visible]: visible,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.content}>
                    <NewsletterFooter visible className={styles.form} onComplete={onComplete} />
                </div>
            </div>
        </div>
    );
};

MediaKitModal.propTypes = propTypes;
MediaKitModal.defaultProps = defaultProps;

export default MediaKitModal;
